import { Editor } from '@tiptap/core';
import { NodeSelection } from '@tiptap/pm/state';

/**
 * Returns true when the given atom node is directly selected (NodeSelection)
 * AND the editor is in edit mode. Selection chrome should not appear in view mode.
 */
const isDirectNodeSelection = (editor: Editor, selected: boolean, isEdit: boolean): boolean =>
  selected && isEdit && editor.state.selection instanceof NodeSelection;

export default isDirectNodeSelection;
